import { tokens } from 'src/design-system';
import { mediaDown } from 'src/design-system/mixins/responsive';

const styles = (theme) => ({
  ...mediaDown(1200, {
    modal: {
      minWidth: '800px',
    },
  }),
  modal: {
    '& .ant-modal-body': {
      padding: 0,
    },
  },
  tabs: {
    padding: tokens.spacing.lg,
    '& .ant-tabs-bar': {
      borderBottom: '0 !important',
      margin: '0 0 3px !important',
    },
  },
  content: {
    '& .ant-tabs-content': {
      padding: 15,
      border: '1px solid #0000000d',
      marginTop: -3,
      // height: 330,
      minWidth: 800,
      overflow: 'overlay',
    }
    // padding: "24px",
    // marginLeft: "12px",
    // marginRight: "100px",
    // borderRadius: '2px',
    // display: 'grid',
    // // gridRowGap: "30px",
    // // gridColumnGap: "100px",
    // gridTemplateColumns: '1fr 3fr',
    // gridAutoRows: 'max-content',
  },
  // ctForm: {
  //   // padding: "24px",
  //   // marginLeft: "12px",
  //   // marginRight: "100px",
  //   borderRadius: '2px',
  //   display: 'grid',
  //   // gridRowGap: "30px",
  //   // gridColumnGap: "100px",
  //   gridTemplateColumns: '1fr 3fr',
  //   gridAutoRows: 'max-content',
  //   width: '85%',
  //   gridColumnGap: '60px',
  // },
  container: {
    // padding: "24px",
    // marginLeft: "12px",
    // marginRight: "100px",
    borderRadius: tokens.radius.sm,
    display: 'grid',
    // gridRowGap: "30px",
    // gridColumnGap: "100px",
    gridTemplateColumns: '1fr 3fr',
    gridAutoRows: 'max-content',
  },
  uploadText: {
    marginBottom: tokens.spacing.md,
    fontSize: tokens.fontSize.small,
    color: '#9F9F9F',
  },
  dragnDropText: {
    fontSize: tokens.fontSize.small,
    color: '#525252',
    marginBottom: 5,
  },
  labelStyle: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    margin: "2% 0 2% 0",
  },
  valueStyle: {
    fontSize: tokens.fontSize.small,
    margin: "2% 0 2% 0",
  },
  uploadStyle: {
    // width: '15%',
    // color: field.disabled ? '#D9D9D9' : '#1890FF',
    // cursor: field.disabled ? 'auto' : 'pointer',
    marginTop: tokens.spacing.md,
    height: '180px !important',
    '& .ant-upload': {
      display: 'flex !important',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .ant-upload-drag-container': {
      display: 'flex !important',
      flexDirection: 'column !important',
    },
  },
  emptyModal: {
    margin: 20,
  },

  contentTitle: {
    color: tokens.colors.text,
    fontFamily: 'Open Sans',
    fontSize: tokens.fontSize.h3,
    fontWeight: 'bold',
    letterSpacing: 0,
  },
  line: {
    borderBottom: '1px solid #D9D9D9',
    opacity: 0.5,
    height: 1,
    width: '98%',
    marginTop: 6,
    marginBottom: 20,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    color: '#666666',
    lineHeight: '14px',
    marginLeft: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
  },
  value: {
    color: tokens.colors.text,
    marginLeft: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
    lineHeight: '14px',
    fontWeight: tokens.fontWeight.semibold,
  },
  contentBox: {
    width: '99%',
    margin: '20px 12px',
  },
  addDocument: {
    padding: `${tokens.spacing.xs}px ${tokens.spacing.sm}px`,
    marginLeft: tokens.spacing.sm,
    borderRadius: 13,
    cursor: 'pointer',
    backgroundColor: '#FAFAFA',
    fontWeight: 'bold',
    fontSize: tokens.fontSize.small,
    color: tokens.colors.primaryDark,
  },
});

export default styles;
